module.exports = __webpack_public_path__ + "fb81373dd0f723e55716ea3956f737f1.pdf";